import { request }               from "./http";
import type { MaintenanceStatus } from "./types";

export type { MaintenanceStatus };

export const getMaintenanceStatus = () =>
  request<MaintenanceStatus>("/maintenance");

export function setMaintenanceMode(active: boolean): Promise<MaintenanceStatus> {
  return request<MaintenanceStatus>("/maintenance", {
    method: "PUT",
    body:   JSON.stringify({ active }),
  });
}
